// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "@media (min-width:960px){.px-md-30[data-v-47408388]{padding:0 25vw}}.place-accordion[data-v-47408388] .v-expansion-panel-content__wrap{padding:0!important}.border-b[data-v-47408388]{-webkit-box-shadow:inset 0 -1px 0 rgba(0,0,0,.25);box-shadow:inset 0 -1px 0 rgba(0,0,0,.25)}", ""]);
// Exports
module.exports = exports;
